import { getStatusColors } from "./assessmentCalendarRules";

export const MULTI_MONTH_GRID_COLS = {
  6: "sm:grid-cols-2",
  12: "sm:grid-cols-2 lg:grid-cols-3",
  24: "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
};

export const COMPACT_DAY_SIZING = {
  6: { cell: "h-8", circle: "h-5 w-5 text-[11px]", dot: "w-[3px] h-[3px]", weekday: "text-[10px]" },
  12: { cell: "h-7", circle: "h-4 w-4 text-[10px]", dot: "w-[3px] h-[3px]", weekday: "text-[9px]" },
  24: { cell: "h-6", circle: "h-4 w-4 text-[9px]", dot: "w-[2px] h-[2px]", weekday: "text-[8px]" },
};

const FULL_MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const SHORT_MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function getCompactSizingKey(calendarViewSpan) {
  if (calendarViewSpan >= 24) return 24;
  if (calendarViewSpan >= 12) return 12;
  return 6;
}

export function getMultiMonthGridColsClass(calendarViewSpan) {
  return MULTI_MONTH_GRID_COLS[calendarViewSpan] || MULTI_MONTH_GRID_COLS[6];
}

export function getAssessmentDensityBarClass(count) {
  if (count >= 4) return "bg-indigo-500";
  if (count >= 2) return "bg-indigo-400";
  if (count >= 1) return "bg-indigo-300";
  return "bg-transparent";
}

export function getVisibleCalendarMonths(anchorYear, anchorMonth, monthSpan = 1) {
  const months = [];
  const span = Math.max(1, Number(monthSpan) || 1);
  for (let i = 0; i < span; i += 1) {
    const date = new Date(anchorYear, anchorMonth + i, 1);
    months.push({ year: date.getFullYear(), month: date.getMonth() });
  }
  return months;
}

export function formatCalendarRangeLabel(anchorYear, anchorMonth, monthSpan = 1) {
  const span = Math.max(1, Number(monthSpan) || 1);
  if (span <= 1) {
    return `${FULL_MONTH_NAMES[anchorMonth]} ${anchorYear}`;
  }
  const end = new Date(anchorYear, anchorMonth + span - 1, 1);
  const endYear = end.getFullYear();
  const endMonth = end.getMonth();
  if (anchorYear === endYear) {
    return `${FULL_MONTH_NAMES[anchorMonth]} – ${FULL_MONTH_NAMES[endMonth]} ${anchorYear}`;
  }
  return `${FULL_MONTH_NAMES[anchorMonth]} ${anchorYear} – ${FULL_MONTH_NAMES[endMonth]} ${endYear}`;
}

export function formatCompactMonthLabel(year, month) {
  return `${SHORT_MONTH_NAMES[month]} ${year}`;
}

export function getCompactDayDotLimit(calendarViewSpan) {
  return calendarViewSpan >= 24 ? 2 : 3;
}

export function getCompactDayNumberCircleClasses(
  status,
  { selected, isToday, hasAssessments } = {},
  sizingKey = 6
) {
  const sizing = COMPACT_DAY_SIZING[sizingKey] || COMPACT_DAY_SIZING[6];
  const base = `mx-auto flex ${sizing.circle} items-center justify-center rounded-full outline-none focus:outline-none`;
  if (!hasAssessments) {
    if (isToday && selected) return `${base} bg-indigo-600 text-white font-semibold`;
    if (isToday) return `${base} text-indigo-600 font-semibold`;
    if (selected) return `${base} bg-indigo-600 text-white font-semibold`;
    return base;
  }
  if (!status) {
    if (selected) return `${base} bg-gray-300 text-gray-900 font-semibold`;
    return `${base} bg-gray-100 font-semibold text-gray-900`;
  }
  const { dot, bg } = getStatusColors(status);
  if (selected) return `${base} ${dot} text-white font-semibold`;
  return `${base} ${bg} font-semibold text-gray-900`;
}
